export default "/images/db18606de3ee6acd7c44f3d681aca468.avif";